import React, { useEffect } from "react";
import "./Shop_By_Material.css";
import Common_Title from "../../common_components/common_title/Common_Title";
import Common_Material_Card from "../../common_components/common_material_card/Common_Material_Card";
import { useDispatch, useSelector } from "react-redux";
import { AllShape } from "../../../features/master/masterSlice";
import { getAllProductsShape } from "../../../features/products/productsSlice";
import { Link } from "react-router-dom";

const Shop_By_Material = () => {
  const shopbymaterial = useSelector((state) => state?.master?.shape || []);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(AllShape());
  }, [dispatch]);

  // console.log(shopbymaterial, "SHAPES DATA");

  return (
    <section className="Shop_By_Material">
      <div className="container">
        <div className="main_div">
          <Common_Title title={"Shop by Material"} />

          <div className="main_content_div">
            <div className="row">
              {/* LEFT COLUMN → first 3 items */}
              <div className="col-md-6">
                <div className="left_div">
                  {shopbymaterial.slice(0, 2).map((item) => (
                  <div className="material_div_holder">

                    <div className="material_div" key={item.id}>
                      <div className="material_div_holder">

                      <Common_Material_Card
                        title={item?.name}
                        imgScr={process.env.REACT_APP_IMG_URL + item?.image}
                        shape_id={item?.id}
                      />
                      </div>
                    </div>
                  </div>
                  ))}
                </div>
              </div>

              {/* RIGHT COLUMN → next 2 items */}
              <div className="col-md-6">
                <div className="two_divs">
                  <div className="row h-100">
                    {shopbymaterial.slice(2, 4).map((item) => (
                      <div className="col-md-6" key={item.id}>
                        <div className="verticle_div">
                          <div className="material_div_holder">

                          <Common_Material_Card
                            title={item?.name}
                            imgScr={process.env.REACT_APP_IMG_URL + item?.image}
                            shape_id={item?.id}
                          />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Link to={"/material"}>
            <div className="view_all_holder">
              <h4>View All Materials</h4>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Shop_By_Material;
// import React, { useEffect } from "react";
// import "./Shop_By_Material.css";
// import Common_Title from "../../common_components/common_title/Common_Title";
// import Common_Material_Card from "../../common_components/common_material_card/Common_Material_Card";
// import { useDispatch, useSelector } from "react-redux";
// import { getAllProductsShape } from "../../../features/products/productsSlice";
// import { AllShape } from "../../../features/master/masterSlice";

// const Shop_By_Material = () => {

//   const shopbymaterial = useSelector((state) => state?.master?.shape);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(AllShape());
//   }, []);

//   console.log(shopbymaterial, "!!!!!!!!!!!!!!!!!!!!")

//   return (
//     <section className="Shop_By_Material">
//       <div className="container">
//         <div className="main_div">
//           <Common_Title title={"Shop by Material"} />

//           <div className="main_content_div">
//             <div className="row">
//               <div className="col-md-6">
//                 <div className="left_div">

//                   {shopbymaterial?.map((item) => (
//                     <div className="material_div" key={item.id}>
//                       <Common_Material_Card
//                         title={item?.name}
//                         imgScr={process.env.REACT_APP_IMG_URL + item?.image}
//                       />
//                     </div>
//                   ))}

//                   {/* <div className="material_div">
//                     <Common_Material_Card
//                       title={"Foam Mattress"}
//                       imgScr={"/assets/images/home/shop/img1.png"}
//                     />
//                   </div> */}

//                   {/* <div className="material_div">
//                     <Common_Material_Card
//                       title={"Foam Mattress"}
//                       imgScr={"/assets/images/home/shop/img2.png"}
//                     />
//                   </div> */}

//                   {/* </div>
//               </div> */}

//                   {/* <div className="col-md-6">
//                 <div className="two_divs">
//                   <div className="verticle_div">
//                     <Common_Material_Card
//                       title={"Foam Mattress"}
//                       imgScr={"/assets/images/home/shop/img3.png"}
//                     />
//                   </div> */}

//                   {/* <div className="verticle_div">
//                     <Common_Material_Card
//                       title={"Foam Mattress"}
//                       imgScr={"/assets/images/home/shop/img4.png"}
//                     />
//                   </div> */}

//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Shop_By_Material;
